import { Box, Container, Stack, Typography, useTheme } from '@mui/material'
import { useEffect } from 'react'

import EElement from '~/features/ui/models'
import Logo from '~/layouts/app/footer/logo'
import Nav from '~/layouts/app/footer/nav'
import TermsAndSocial from '~/layouts/app/footer/termsAndSocial'
import rem from '~/utils/ui'

type TProps = {
  isMarketingPage?: boolean
}

function Footer({ isMarketingPage = false }: TProps) {
  const theme = useTheme()

  useEffect(() => {
    if (!isMarketingPage) {
      return () => {}
    }
    const source = 'js/marketingTracking.js'

    const isAlreadyAppended = document.body.querySelector(
      `script[src*="${source}"]`,
    )

    if (isAlreadyAppended) {
      return () => {}
    }

    const script = document.createElement('script')
    script.src = source
    script.async = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [isMarketingPage])

  return (
    <Box
      component="footer"
      id={EElement.appFooter}
      sx={{
        backgroundColor: theme.palette.menuBackground,
        zIndex: { sm: 2 },
        pt: rem(60),
        pb: rem(60),
        color: theme.palette.common.white,
      }}
    >
      <Container>
        <Stack
          sx={{ flexDirection: { xxxs: 'column', lg: 'row' } }}
          spacing={4}
          useFlexGap
        >
          <Box sx={{ flex: 1 }}>
            <Logo />
            <Typography>
              Save time and get more members
              <br />
              with your 24/7 AI Team Member.
            </Typography>
          </Box>
          <Nav />
        </Stack>
        <TermsAndSocial />
      </Container>
    </Box>
  )
}

export default Footer
